import React from "react";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import Header from "../Header";
import Companies0529 from "../components/Companies0529";
import Head from "../components/Head";
import Companies from "../components/Companies";
import University from "../components/university";
import arrow from "../assets/images/arrow.png";
import sessionImage from "../assets/images/sessionImage.png";
import logo from "../assets/images/logo.png";
import headImage from "../assets/images/session0529/session0529head.png";
import dialogger from "../assets/images/dialogger.png";

import Twemb from "../Twemb";
import "../css/session0529.css";

const session0529 = (props) => {
  return (
    <>
      <Head
        title="第二回！オンライン合同企業説明会2020"
        body="5月29日にオンラインで合同企業説明会を行います。大手企業など北海道に拠点を持つ18社が参加予定！"
      />
      <img
        src={headImage}
        className="headImage2"
        alt="headerImage"
        onMouseDownCapture={() => {
          return false;
        }}
        onSelectCapture={() => {
          return false;
        }}
      />
      <p style={{ textAlign: "center" }}>参加はこちらから！</p>
      <p className="form2">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
          参加申込フォーム
        </a>
      </p>

      <div className="container">
        <Header title="開催にあたって" name="peach-header2" />
        <p className="contents">
          4/25に実施した道内オンライン合同企業説明会では約700名と23社の参加があり、引き続き継続して実施することになりました！新型コロナウィルスの影響で対面式の合同企業説明会が中止になる中、道内学生と道内に拠点を持つ企業の合同企業説明会を実施します。オンライン就活始めてみませんか？
        </p>

        <Header title="関連イベント" name="peach-header2" />
        <p className="contents">
          <Link to="/session0614">
            2020/6/14 22卒、その他の学年向けオンライン合同説明会
          </Link>
        </p>
        <Header title="開催予定日" name="peach-header2" />
        <p className="contents">5月29日（金）10時〜18時（予定）</p>

        <Header title="対象" name="peach-header2" />
        <p className="contents">道内企業と道内就職希望の学生（21卒）</p>
        <p className="form2">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
            参加申込フォーム
          </a>
        </p>

        <Header title="オンライン合説のイメージ" name="peach-header2" />
        <img
          src={sessionImage}
          className="contents sessionImage"
          alt="sessionImage"
        />

        <Header title="参加方法・用意するもの" name="peach-header2" />
        <p className="form2">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
            参加申込フォーム
          </a>
        </p>
        <p className="contents">
          ・上のボタンより、参加申込みをお願いいたします。
          <br />
          ・当日使用するスマホ・PCに、「zoom」アプリをインストールしておいてください。
          <br />
          （iPhoneは
          <a href="https://apps.apple.com/us/app/id546505307">コチラ</a>{" "}
          、Androidは
          <a href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings">
            コチラ
          </a>{" "}
          、PCは<a href="https://zoom.us/download#client_4meeting">コチラ</a>
          インストール所要時間5分程度）
          <br />
          ・当日使用するzoomのURL（登録メールアドレスに前日までにお送りいたします）
          <br></br>
          ・【任意】企業の事前配布資料を読んできてください(一部の企業のみ)。事前配布資料は以下のボタンでGoogleドライブからダウンロードすることができます。
        </p>
        <p className="pre0529">
          <a href="https://drive.google.com/drive/folders/1SDVSjANQOOlo9kxrytO84296L55Rr3yV">
            事前配布資料
          </a>
        </p>

        <Header title="当日のスケジュール" name="peach-header2" />
        <table className="tg contents">
          <tbody>
            <tr>
              <th></th>
              <th className="centerTitle1">部</th>
              <th className="centerTitle1">全体の流れ</th>
              <th className="centerTitle2">ルームA</th>
              <th className="centerTitle2">ルームB</th>
              <th className="centerTitle2">ルームC</th>
              <th className="centerTitle2">ルームD</th>
            </tr>
            <tr>
              <td className="center time">10:00〜10:10</td>
              <th className="center compSession1" rowSpan="7">
                第一部
              </th>
              <td className="center compSession1">全体説明・挨拶</td>
              <td className="center compSession2" colSpan="5">
                全体説明・挨拶
              </td>
            </tr>
            <tr>
              <td className="center time">10:10〜10:40</td>
              <td className="center compSession1">１ターム</td>
              <td className="center compSession2">
                コープさっぽろ(生活協同組合)
              </td>
              <td className="center compSession2">
                りらいあコミュニケーションズ(各種ビジネスサービス)
              </td>
              <td className="center compSession2">
                キットアライブ(IT（システム開発）)
              </td>
              <td className="center compSession2">不二建設(建設)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">10:50〜11:20</td>
              <td className="center compSession1">2ターム</td>
              <td className="center compSession2">
                イオン北海道(流通・小売業)
              </td>
              <td className="center compSession2">学習塾あすなろ会(学習塾)</td>
              <td className="center compSession2">
                クリプトンフューチャーメディア(IT・ソフトウェア)
              </td>
              <td className="center compSession2">道路建設(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">11:30〜12:00</td>
              <td className="center compSession1">3ターム</td>
              <td className="center compSession2">ニューホランド(商社)</td>
              <td className="center compSession2">
                さくらＣＳホールディングス(医療・福祉)
              </td>
              <td className="center compSession2">
                ミクロスソフトウェア(ソフトウェア開発)
              </td>
              <td className="center compSession2">檜山鐵工所(鉄工業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">12:10〜12:50</td>
              <td className="center column" colSpan="7">
                コンテンツ①コロナ禍における就職活動　パーソルキャリア株式会社　CAMPキャプテン(ルームAで行います)
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <th className="center compSession1" rowSpan="7">
                第二部
              </th>
              <td className="center arrow" colSpan="6">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">13:00〜13:10</td>
              <td className="center compSession1">全体説明・挨拶</td>
              <td className="center compSession2" colSpan="5">
                全体説明・挨拶
              </td>
            </tr>
            <tr>
              <td className="center time">13:10〜13:40</td>
              <td className="center compSession1">4ターム</td>
              <td className="center compSession2">久原本家(食品)</td>
              <td className="center compSession2">ロゴスホーム(住宅・建設)</td>
              <td className="center compSession2">
                合田観光商事(アミューズメント)
              </td>
              <td className="center compSession2">道路建設(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">13:50〜14:20</td>
              <td className="center compSession1">5ターム</td>
              <td className="center compSession2">ニューホランド(商社)</td>
              <td className="center compSession2">
                りらいあコミュニケーションズ(各種ビジネスサービス)
              </td>
              <td className="center compSession2">
                クリプトンフューチャーメディア(IT・ソフトウェア)
              </td>
              <td className="center compSession2">不二建設(建設)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">14:30〜15:00</td>
              <td className="center compSession1">6ターム</td>
              <td className="center compSession2">
                イオン北海道(流通・小売業)
              </td>
              <td className="center compSession2">
                さくらＣＳホールディングス(医療・福祉)
              </td>
              <td className="center compSession2"></td>
              <td className="center compSession2">井上技研(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">15:10〜15:50</td>
              <td className="center column" colSpan="7">
                コンテンツ②正直、みんな就活どうしてるの？現役人事が相談乗ります！生活協同組合コープさっぽろ
                小濱様 ・株式会社キットアライブ 内田様(ルームAで行います)
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <th className="center compSession1" rowSpan="7">
                第三部
              </th>
              <td className="center arrow" colSpan="6">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">16:00〜16:10</td>
              <td className="center compSession1">全体説明・挨拶</td>
              <td className="center compSession2" colSpan="5">
                全体説明・挨拶
              </td>
            </tr>
            <tr>
              <td className="center time">16:10〜16:40</td>
              <td className="center compSession1">7ターム</td>
              <td className="center compSession2">
                コープさっぽろ(生活協同組合)
              </td>
              <td className="center compSession2">学習塾あすなろ会(学習塾)</td>
              <td className="center compSession2">
                合田観光商事(アミューズメント)
              </td>
              <td className="center compSession2">井上技研(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">16:50〜17:20</td>
              <td className="center compSession1">8ターム</td>
              <td className="center compSession2">久原本家(食品)</td>
              <td className="center compSession2">ロゴスホーム(住宅・建設)</td>
              <td className="center compSession2">
                キットアライブ(IT（システム開発）)
              </td>
              <td className="center compSession2">檜山鐵工所(鉄工業)</td>
            </tr>
          </tbody>
        </table>
        <p className="contents">
          当日スケジュールは予定です。参加企業数や運営の都合により変更することがございます。
        </p>

        <Header title="出展予定企業" name="peach-header2" />
        <Companies0529 data={props.companies.companies0529} />

        <Header title="出展実績" name="peach-header2" />
        <Companies data={props.companies.companies} />

        <Header title="学生実績" name="peach-header2" />
        <University data={props.companies.university0425} />

        <Header title="過去取材実績" name="peach-header2" />
        <ul className="contents">
          <li>
            <a href="・https://www.hokkaido-np.co.jp/article/411292">
              北海道新聞
            </a>
          </li>
          <li>
            <a href="https://www.nikkei.com/article/DGXMZO58470250U0A420C2L41000/">
              日経新聞
            </a>
          </li>
          <li>朝日新聞(5/18掲載予定)</li>
          <li>NHK:おはよう北海道(5/7)</li>
          <li>
            <a href="https://this.kiji.is/633488200549614689?c=462419638605612129">
              Tvh:けいナビ
            </a>
          </li>
        </ul>

        <Header title="企業様の参加方法" name="peach-header2" />
        <p className="contents">
          企業担当者様は
          <a href="https://docs.google.com/presentation/d/1KwjyN0Af_yDufyyF-Qz2TB0mmbd4ewc7PrD8FRaxuXE/edit?usp=sharing">
            こちら！(受付中)
          </a>
        </p>

        <Header title="主催/共催" name="peach-header2" />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://13labo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={logo}
                  />
                </a>
                <p className="companyTitle">主催：13LABO(株式会社オガワヤ)</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://www.dialogger-inc.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={dialogger}
                  />
                </a>
                <p className="companyTitle">共催：合同会社Dialogger</p>
              </div>
            </Grid>
          </Grid>
          <Twemb />
        </div>

        {/*} <Header title='協力' />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://kk.hokkaido-np.co.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={hokkaido} />
                </a>
                <p className="companyTitle">北海道新聞社</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://jobdas.hokkaido-np.co.jp/2021/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={jobdas} />
                </a>
                <p className="companyTitle">ジョブダス就活</p>
              </div>
            </Grid>
          </Grid>
        </div>

        <Header title='後援' />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://www.pref.hokkaido.lg.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={white} />
                </a>
                <p className="companyTitle">北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://www.city.sapporo.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={sapporo} />
                </a>
                <p className="companyTitle">札幌市</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://www.jobcafe-h.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={jobcafe} />
                </a>
                <p className="companyTitle">ジョブカフェ北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://no-maps.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={noMaps} />
                </a>
                <p className="companyTitle">NoMaps実行委員会</p>
              </div>
            </Grid>
          </Grid>
      </div>*/}

        <Header title="その他お問い合わせ" name="peach-header2" />
        <p className="contents">
          13LABOホームページよりお問い合わせください。
          <a href="https://13labo.com">お問い合わせフォーム</a>
        </p>

        <Header title="Special Thanks!" name="peach-header2" />
        <p className="contents">
          idea from<a href="https://twitter.com/jony_fj">ジョニー藤村様</a>
          <br />
          created by <a href="https://twitter.com/tanakarn98">tanaka</a>
          <br />
          icon from<a href="https://icons8.com">icons8</a>
        </p>
      </div>
    </>
  );
};

export default session0529;
